import script from "./OngoingOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./OngoingOrders.vue?vue&type=script&setup=true&lang=js"

import "./OngoingOrders.vue?vue&type=style&index=0&id=66693da4&lang=css"

const __exports__ = script;

export default __exports__